// import {DeepChat as DeepChatCore} from 'deep-chat'; <- type
import { DeepChat } from "deep-chat-react";
import { RequestDetails } from "deep-chat/dist/types/interceptors";
import "./style.css";

export const App = () => {
  return (
    <div className="App">
      <h1>Homespark</h1>
      <DeepChat
        connect={{ url: `${process.env.REACT_APP_API_URL}/chat-stream`, stream: true }}
        style={{ borderRadius: "10px", width: "360px", height: "728px" }}
        requestBodyLimits={{ maxMessages: 0 }}
        requestInterceptor={(details: RequestDetails) => {
          const latestMessage =
            details.body.messages[details.body.messages.length - 1].text;
          details.body.input = `{"user_query": "${latestMessage}", "model_provider": "openai", "model_reference": "gpt-4o"}`;
          return details;
        }}
        textInput={{ placeholder: { text: "Ask me anything..." } }}
      />
    </div>
  );
};
